export const isApproval = (test) => !!test.match(/approval/)
export const isTask = (test) => !!test.match(/task/)

export const WorkflowLocation = {
  Panel: 'workflowPanel',
  Popover: 'workflowPopover',
}

export const isInWorkflowPopover = (workflowLocation) =>
  workflowLocation === WorkflowLocation.Popover
